import { render, staticRenderFns } from "./goBack.vue?vue&type=template&id=75e6549d&scoped=true"
import script from "./goBack.vue?vue&type=script&lang=js"
export * from "./goBack.vue?vue&type=script&lang=js"
import style0 from "./goBack.vue?vue&type=style&index=0&id=75e6549d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e6549d",
  null
  
)

export default component.exports